import routeConfig from '../constants/routeConfig'
import routeUtils from '../util/routeUtils'
import fragmentUtils from '../util/fragmentUtils'

export default {
  provide () {
    return {
      $fragment: this
    }
  },
  methods: {
    openFragment (relativePath, routeQuery) {
      let parentPath = routeUtils.getCurrentRoutePath(this, this.$route)
      let routePaths = []
      if (parentPath) {
        routePaths.push(parentPath)
      }
      routePaths.push(`/fragment/${relativePath}`)
      this.$router.push({
        path: routePaths.join(''),
        query: this.$extend(routeQuery, {
          [routeConfig.Redirect.id]: routeUtils.getRouteMatchId(this, this.$route)[0]
        })
      })
    },
    hideFragment () {
      let parentPath = routeUtils.getCurrentRoutePath(this, this.$route)
      let routePaths = []
      if (parentPath) {
        routePaths.push(parentPath)
      }
      let matchId = routeUtils.getRouteMatchId(this, this.$route)[0]
      routePaths.push(matchId)
      this.$router.push({
        path: routePaths.join('')
      })
      fragmentUtils.delPath(matchId)
    },
    saveFragment (fragment) {
      let matchId = routeUtils.getRouteMatchId(this, this.$route)[0]
      let fragmentUrl = `/fragment/${fragment.pathMatch}`
      let fragmentQuery = [
        `postId=${fragment.postId}`,
        `${routeConfig.Redirect.id}=${encodeURIComponent(matchId)}`
      ]
      fragmentUtils.setPath(matchId, fragmentUrl + '?' + fragmentQuery.join('&'))
    },
    deleteFragment (matchId) {
      fragmentUtils.delPath(matchId)
    }
  }
}
